/* ContentLockedCard — rendered when a content fetch returns __locked.
   Free & Open plan: no sign-up. Visitors get 3 pathways per device every 24 hours. */
import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight, ShieldCheck } from 'lucide-react';

const ContentLockedCard = ({ title = 'This preview isn\'t open right now', message }) => (
  <div
    className="max-w-xl mx-auto my-12 bg-white border-2 border-amber-300 rounded-3xl p-8 md:p-10 text-center shadow-md"
    data-testid="content-locked-card"
  >
    <span className="inline-flex w-14 h-14 rounded-2xl bg-amber-100 text-amber-700 items-center justify-center mb-3">
      <Lock size={26} />
    </span>
    <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-2">{title}</h2>
    <p className="text-[15px] text-gray-700 leading-relaxed mb-6 max-w-md mx-auto">
      {message
        || 'LearnixTa is free and needs no account — every device can open 3 pathways every 24 hours. You may have used today\u2019s three, or this content sits inside a path you haven\u2019t opened yet. Start from your dashboard.'}
    </p>
    <div className="flex flex-col sm:flex-row gap-2.5 justify-center">
      <Link
        to="/dashboard"
        data-testid="content-locked-dashboard"
        className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-600 text-gray-900 font-extrabold px-5 py-3 rounded-full transition-colors"
      >
        Go to my dashboard <ArrowRight size={15} />
      </Link>
      <Link
        to="/life-skills"
        data-testid="content-locked-lifeskills"
        className="inline-flex items-center justify-center gap-2 border border-gray-300 hover:bg-gray-50 text-gray-700 font-bold px-5 py-3 rounded-full transition-colors"
      >
        Open Life Skills (always free)
      </Link>
    </div>
    <p className="text-[11px] text-gray-500 mt-5 inline-flex items-center gap-1.5 justify-center">
      <ShieldCheck size={12} className="text-emerald-600" /> 100% free &middot; no sign-up &middot; 3 paths every 24 hours
    </p>
  </div>
);

export default ContentLockedCard;
